<template>
  <ul class="tabs" :class="`tabs--${theme}`">
    <li @click.prevent="onChange(item.name)" v-for="item in items" :class="tabItemModifiers(item)">
      <a href="#" :class="tabLinkModifiers(item)">
        <template v-if="item.icon">
          <span :class="tabIconModifiers(item)"></span>
        </template>
        <template v-else>
          <div class="tabs__title">
            {{ item.title }}
          </div>
          <div v-if="item.subtitle" class="tabs__subtitle" v-html="item.subtitle"></div>
          <div v-if="item.meta && item.meta.numRuleComments > 0" class="tabs__rule-comments-count">
            {{ item.meta.numRuleComments }}
          </div>
        </template>
      </a>
    </li>
  </ul>
</template>

<script src="./tabs.js"></script>
<style src="./tabs.scss" lang="scss"></style>
